import React, { useState } from "react";
import { Card, CardBody } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { PrimaryButton, SmallButton } from "../../../../Constant";
import { Btn, ToolTip } from "../../../../AbstractElements";
import CommonEdgeButton from "../Common/CommonEdgeButton";
import { EDGE_SMALL_BUTTONS, EDGE_SMALL_BUTTONS_LIST } from "../../../../Data/Buttons/EdgeStyle";

const EdgeSmallButtons = () => {
  const [buttonTooltip, setButttooltip] = useState(false);
  const buttonToggle = () => setButttooltip(!buttonTooltip);
  return (
    <Card>
      <CommonCardHeader title={SmallButton} span={EDGE_SMALL_BUTTONS} />
      <CardBody className="btn-showcase">
        <Btn size="sm" color="primary" className="btn-pill" id="Tooltip-15">{PrimaryButton}</Btn>
        <ToolTip target="Tooltip-15" isOpen={buttonTooltip} toggle={buttonToggle}>btn btn-pill btn-primary btn-sm</ToolTip>
        {EDGE_SMALL_BUTTONS_LIST.map((data, index) => (
          <CommonEdgeButton key={index} item={data} size="sm" />
        ))}
      </CardBody>
    </Card>
  );
};

export default EdgeSmallButtons;
